import React from 'react';
import { Breadcrumb, Typography, Space } from 'antd';
import { HomeOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import PurchaseList from '../components/Purchases/PurchaseList';
import PurchaseSummary from '../components/Purchases/PurchaseSummary';

const { Title } = Typography;

const PurchasesPage = () => {
    return (
        <div>
            <Breadcrumb
                style={{ marginBottom: '16px' }}
                items={[
                    {
                        href: '/',
                        title: <HomeOutlined />,
                    },
                    {
                        title: (
                            <Space>
                                <ShoppingCartOutlined />
                                <span>Purchases</span>
                            </Space>
                        ),
                    },
                ]}
            />

            <PurchaseSummary />
            <PurchaseList />
        </div>
    );
};

export default PurchasesPage;

